import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { fromEvent, merge, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Directive({
    selector: '[cmpsInsightSelectionCollapse]',
})
export class SelectionCollapseInsightDirective implements OnInit, OnDestroy {
    private _done: Subject<void>;

    constructor(private readonly _el: ElementRef) {}

    ngOnInit(): void {
        this._done = new Subject();

        const setState = (which: string): void => {
            const pair = which === 'show' ? ['none', ''] : ['', 'none'];
            const summary = this._el.nativeElement.querySelector(
                '[data-insight-snce-summary]',
            );
            const full = this._el.nativeElement.querySelector(
                '[data-insight-snce-full]',
            );
            if (!summary || !full) return;
            summary.style.display = pair[0];
            full.style.display = pair[1];
        };

        const setBtnState = (which: string, eventType: string): void => {
            const attrSelector =
                which === 'show'
                    ? '[data-insight-snce-summary]'
                    : '[data-insight-snce-full]';
            const el = this._el.nativeElement.querySelector(attrSelector);
            if (eventType === 'mouseenter') {
                el.classList.add('insight-snce-hover');
            }
            if (eventType === 'mouseleave') {
                el.classList.remove('insight-snce-hover');
            }
        };

        const toggle = (btn: HTMLElement): void => {
            merge<MouseEvent | KeyboardEvent>(
                fromEvent(btn, 'mouseenter'),
                fromEvent(btn, 'mouseleave'),
            )
                .pipe(
                    takeUntil(this._done),
                    // eslint-disable-next-line @typescript-eslint/dot-notation
                    tap((e) =>
                        // eslint-disable-next-line @typescript-eslint/dot-notation
                        setBtnState(btn.dataset['insightSnceToggle'], e.type),
                    ),
                )
                .subscribe();

            fromEvent<MouseEvent | KeyboardEvent>(btn, 'click')
                .pipe(
                    takeUntil(this._done),
                    // eslint-disable-next-line @typescript-eslint/dot-notation
                    tap(() => setState(btn.dataset['insightSnceToggle'])),
                )
                .subscribe();
        };

        setState('hide');

        const btns = Array.from<HTMLElement>(
            this._el.nativeElement.querySelectorAll(
                '[data-insight-snce-toggle]',
            ),
        );
        btns.forEach((e) => toggle(e));
    }

    ngOnDestroy(): void {
        this._done.next();
    }
}
